import { reactive } from 'vue';
import { getOrganizations, getOrganizationsNumberByCCAA } from '@/api';

export default function () {
  const organizations = reactive({
    data: [],
    loading: false,
    error: false,
  });

  const organizationsNumberByCCAA = reactive({
    data: [],
    loading: false,
    error: false,
  });

  const handleFetchOrganizations = () => {
    organizations.loading = true;
    setTimeout(
      async () => {
        try {
          organizations.data = await getOrganizations();
        } catch (e) {
          organizations.error = true;
        } finally {
          organizations.loading = false;
        }
      },
      1000,
    );
  };

  const handleFetchOrganizationsNumber = () => {
    organizationsNumberByCCAA.loading = true;
    setTimeout(
      async () => {
        try {
          organizationsNumberByCCAA.data = await getOrganizationsNumberByCCAA();
        } catch (e) {
          organizationsNumberByCCAA.error = true;
        } finally {
          organizationsNumberByCCAA.loading = false;
        }
      },
      500,
    );
  };

  return {
    organizations,
    handleFetchOrganizations,
    organizationsNumberByCCAA,
    handleFetchOrganizationsNumber,
  };
}
